import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EMZI_COLORS, EMZI_RADIUS } from '../../styles/emziCI';
import { txt } from '../../utils/bilingualText';

const PACK_TYPE_COLORS = {
  product: '#3B82F6',      // Blue
  promotion: '#F59E0B',    // Amber
  values: '#8B5CF6',       // Purple
  compliance: '#EF4444',   // Red
  direction: '#10B981',    // Green
  services: '#06B6D4',     // Cyan
  ambassador: '#EC4899',   // Pink
  health: '#14B8A6',       // Teal
  viral: '#F97316',        // Orange
  trend: '#6366F1',        // Indigo
};

const PackChip = ({ pack, onClick }) => {
  const navigate = useNavigate();
  const bgColor = PACK_TYPE_COLORS[pack.pack_type] || EMZI_COLORS.primary;

  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick) {
      onClick(pack);
    } else {
      // Navigate to pack details
      navigate(`/knowledge-packs/${pack.pack_id}`);
    }
  };

  return (
    <div
      onClick={handleClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '4px 8px',
        backgroundColor: bgColor,
        color: '#FFFFFF',
        borderRadius: EMZI_RADIUS.full,
        fontSize: '10px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'transform 0.2s, box-shadow 0.2s',
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        whiteSpace: 'nowrap',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.05)';
        e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.3)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.2)';
      }}
      title={`${pack.pack_type}: ${txt(pack.name)}`}
    >
      <span>{getPackIcon(pack.pack_type)}</span>
      <span>{txt(pack.name)}</span>
    </div>
  );
};

const getPackIcon = (packType) => {
  const icons = {
    product: '🧃',
    promotion: '🎯',
    values: '💎',
    compliance: '⚖️',
    direction: '🧭',
    services: '🏥',
    ambassador: '🌟',
    health: '💚',
    viral: '🔥',
    trend: '📈',
  };
  return icons[packType] || '📦';
};

export default PackChip;
